import { createContext } from 'react';
import { Toggle } from '../../types/toggles';
import { Loadable } from '../../types/commonTypes';

export const FeatureToggleContext = createContext<Loadable<Toggle[]>>({
  loading: false,
  result: null,
  error: null,
});
